import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';
import Modal from '../../../_common/Modal/Modal';
import accountHelpers from '../../../../utils/accountHelpers';
import classes from './faxModal.module.scss';
import InputField from '../../../_common/Form/TextFields/InputField';
import { getScriptsRequest } from '../../../../store/actions/script';
import SortpakLogo from '../../../../assets/icons/sortpak-logo-fax.png';
import Loader from '../../../_common/Loader/Loader';
import Button from '../../../_common/Form/Buttons/Button';
import utils from '../../../../utils/utils';
import api from '../../../../api/api';
import { getRefillsRequest } from '../../../../store/actions/refills';
import { useQuery } from '../../../../utils/hooks/useQuery';

const info = [
  'ALL ABOVE SCRIPTS ARE AUTHORIZED FOR ONE TIME PLUS ______ ADDITIONAL REFILLS',
  'SCRIPTS ARE INDIVIDUALLY AUTHORIZED IN THE ABOVE LIST',
  'NOT AUTHORIZED. PATIENT NEEDS TO CALL DOCTORS OFFICE',
];

const FaxModal = ({
  modalData, onClose, status,
}) => {
  const dispatch = useDispatch();
  const scriptData = useSelector((store) => store.script.scriptData);
  const { query } = useQuery();

  const [loading, setLoading] = useState(true);
  const [loadBtn, setLoadBtn] = useState({
    preview: false,
    fax: false,
  });
  const [script, setScript] = useState([]);
  const [comment, setComment] = useState('');
  const [fax, setFax] = useState('');
  const [checkedInfo, setCheckedInfo] = useState([]);
  const [checkedGender, setCheckedGender] = useState(null);

  const addressPatient = _.compact([scriptData[0]?.Patient?.addressCity,
    scriptData[0]?.Patient?.addressState,
    scriptData[0]?.Patient?.addressZipCode]);

  const addressPhysician = _.compact([scriptData[0]?.Physician?.addressCity,
    scriptData[0]?.Physician?.addressState,
    scriptData[0]?.Physician?.addressZipCode]);

  const allScript = scriptData.map((p) => p);
  const isCheckedAllScript = allScript.every((data) => !!script.find((s) => data.id === s?.id));

  useEffect(() => {
    if (!_.isEmpty(modalData)) {
      (async () => {
        setLoading(true);

        await dispatch(getScriptsRequest({
          userId: accountHelpers.getUser().id,
          patientId: modalData.patientId,
          physicianId: modalData.physicianId,
          status,
          limit: 100,
        }));

        setLoading(false);
      })();
    }
  }, [modalData]);

  useEffect(() => {
    setFax(scriptData[0]?.Physician?.fax);
  }, [scriptData]);

  const onKeyPress = (e, isPaste) => {
    utils.keyPressPhoneNumber(e, isPaste);
  };

  const changeCheckbox = (check, id) => {
    if (id === 'all') {
      if (isCheckedAllScript) {
        setScript([]);
      } else {
        setScript(allScript);
      }
    } else if (script.some((s) => s.id === id)) {
      setScript(script.filter((s) => s.id !== id));
    } else {
      setScript([...script, ...scriptData.filter((s) => s.id === id)]);
    }
  };

  const changeData = (value, type) => {
    if (type === 'fax') {
      setFax(value);
    } else {
      setComment(value);
    }
  };

  const downloadFaxPgf = async (e) => {
    e.preventDefault();

    const input = document.getElementById('divToPrint');

    setLoadBtn((prev) => ({ ...prev, preview: true }));

    await html2canvas(input, {
      scale: '3',
    })
      .then((canvas) => {
        const pdf = new jsPDF();
        pdf.addImage(canvas, 'JPEG', 0, 0, 200, 300);
        pdf.save('Fax_Preview.pdf');
      });

    setLoadBtn((prev) => ({ ...prev, preview: false }));
  };

  const sendFax = async () => {
    if (_.isEmpty(script)) {
      toast.error('Fax has 0 scripts attached, please check the document');
      return;
    }

    setLoadBtn((prev) => ({ ...prev, fax: true }));

    try {
      const input = document.getElementById('divToPrint');

      const clone = input.cloneNode(true);
      clone.querySelectorAll('input[type="checkbox"]').forEach((el) => {
        if (el.checked) {
          el.setAttribute('checked', '');
        } else {
          el.removeAttribute('checked');
        }
      });

      const fileName = `fax-${Date.now()}.html`;
      const htmlContent = `<!DOCTYPE html><html><head><meta charset="utf-8"><link rel="preconnect" href="https://fonts.googleapis.com"><link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap" rel="stylesheet"><style>*{font-family:'Inter',sans-serif;}input[type="checkbox"]{-webkit-appearance:checkbox;appearance:checkbox;width:14px;height:14px;cursor:pointer;accent-color:#000;}</style></head><body style="margin: 0">${clone.outerHTML}</body></html>`;
      const attachmentFile = new File([htmlContent], fileName, { type: 'text/html' });

      const formData = new FormData();

      formData.append('attachmentFile', attachmentFile);

      toast.success(`Sending Fax to ${fax}`);

      await api.sendInsuranceFile({
        formData,
        fileName,
        faxes: true,
        scriptId: script[0].id,
      });

      const { data } = await api.uploadRefileFax({
        fileName, faxNumber: fax, scriptId: script.map((s) => s.id).join(','), attachmentFile,
      });

      if (data === 'Access Denied') {
        toast.error('Access Denied!');
      } else {
        const date = moment().format('YYYY-MM-DD');

        for (let i = 0; i < script.length; i += 1) {
          const faxNumber = Number.isNaN(+script[i].faxNum) ? 0 : +script[i].faxNum;

          await api.scriptFaxUpload({
            id: script[i].id,
            faxNum: +faxNumber + 1,
            lastFaxed: date,
            manual: true,
          });
        }

        toast.success('Fax successfully sent');

        await dispatch(getRefillsRequest({
          status: query.status || 'Refill',
          textSearch: query.textSearch || '',
          rep: query.rep || '',
          spec: query.spec || '',
          page: query.page || 1,
          limit: query.limit || 15,
          userId: accountHelpers.getUser().id,
        }));

        onClose();
      }
      // } else {
      //   toast.error('Your fax was not send successfully');
      // }
    } catch (e) {
      const message = e.response?.data?.error?.message;
      toast.error(message || 'Unable to send a fax. Please contact your administrator.');
    }

    setLoadBtn((prev) => ({ ...prev, fax: false }));
  };

  // Authorization # / Confirmation # belong only to manufacturer (BMS) products,
  // so check the scripts actually attached to this fax, not the first fetched one.
  const hasManufacturerId = script.some((s) => !!s?.Product?.manufacturerId);

  return (
    <Modal
      onClose={onClose}
      open={!_.isEmpty(modalData)}
      className={classes.modal_wrapper}
    >

      {loading
        ? <Loader />

        : (
          <div>
            <div className={classes.wrapper}>
              <div className={classes.input_wrapper}>
                <div>
                  <InputField
                    label="Fax Number"
                    value={fax}
                    onChange={(value) => changeData(value, 'fax')}
                    onKeyPress={(e) => onKeyPress(e)}
                    onPaste={(e) => onKeyPress(e, true)}
                  />
                </div>

                <div>
                  <InputField
                    label="Comments"
                    value={comment}
                    textareaField
                    onChange={(value) => changeData(value, 'comment')}
                  />
                </div>
              </div>

              <div className={classes.table}>
                <table>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={(e) => changeCheckbox(e.target.checked, 'all')}
                          checked={isCheckedAllScript}
                        />
                      </th>

                      <th>Refill On</th>

                      <th>Medication</th>

                      <th>Physician</th>

                      <th>Group</th>
                    </tr>
                  </thead>

                  <tbody>
                    {scriptData.map((s) => (
                      <tr key={s.id}>
                        <td>
                          <input
                            type="checkbox"
                            onChange={(e) => changeCheckbox(e.target.checked, s.id)}
                            // checked={scriptIds.includes(s.id)}
                            checked={!!script.find((data) => data.id === s.id)}
                          />
                        </td>

                        <td>{moment(s.processedOn).format('MM/DD/YYYY')}</td>

                        <td>{s.Product.name}</td>

                        <td>{`${s.Physician?.firstName} ${s.Physician?.lastName}`}</td>

                        <td>{s.Physician?.group ? s.Physician?.group : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>

            <h2>FAX PREVIEW</h2>

            <div style={{
              height: 20, background: '#FFFFFF', width: '210mm', margin: 'auto',
            }}
            />

            <div
              id="divToPrint"
              style={{
                width: '210mm',
                fontWeight: 'bold',
                background: '#FFFFFF',
                padding: '0 15px',
                margin: '0 auto',
              }}
            >
              <div style={{ padding: '0 10px 10px' }}>
                <img
                  alt="SortPak"
                  src={SortpakLogo}
                  style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                />
                <h3 style={{ margin: '10px 0' }}>Refill Authorization Request</h3>
                <p style={{ margin: 0 }}>{`Sent on ${moment().format('MM/DD/YYYY')}`}</p>
                <p style={{ margin: 0 }}>Please utilize electronic prescribing when possible.</p>
              </div>

              <div style={{ margin: '10px 10px 10px auto', padding: 0, width: 210 }}>
                <div style={{
                  textAlign: 'right', fontSize: '14px', color: '#1D2740',
                }}
                >
                  655 N Central Ave 22nd Floor
                </div>
                <div style={{
                  textAlign: 'right', fontSize: '14px', color: '#1D2740',
                }}
                >
                  Glendale, Ca 91203
                </div>
                <div style={{
                  textAlign: 'right', fontSize: '14px', color: '#1D2740',
                }}
                >
                  TEL: (877) 570-7787
                </div>
                <div style={{
                  textAlign: 'right', fontSize: '14px', color: '#1D2740',
                }}
                >
                  FAX: (877) 475-2382
                </div>
              </div>

              <div style={{ marginTop: '25px', width: '100%' }}>
                <table style={{ width: '100%', textAlign: 'left' }}>
                  <thead style={{ textAlign: 'left', fontSize: '14px' }}>
                    <tr>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Patient name</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Date of birth</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Phone</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Address</th>
                    </tr>
                  </thead>

                  <tbody style={{ textAlign: 'left', fontSize: '16px' }}>
                    <tr>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{`${scriptData[0].Patient.firstName} ${scriptData[0].Patient.lastName}`}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{moment(scriptData[0].Patient.dob).format('MM/DD/YYYY')}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{scriptData[0].Patient.phone}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>
                        {scriptData[0].Patient?.addressStreet ? `${scriptData[0].Patient.addressStreet},` : ''}
                        <br />
                        {!_.isEmpty(addressPatient) && addressPatient.join(', ')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={{ marginTop: '25px', width: '100%' }}>
                <table style={{ width: '100%', textAlign: 'left' }}>
                  <thead style={{ textAlign: 'left', fontSize: '14px' }}>
                    <tr>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Physician name</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Phone</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Fax</th>
                      <th style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>Address</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{`${scriptData[0].Physician.firstName} ${scriptData[0].Physician.lastName}`}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{scriptData[0].Physician.phone}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>{scriptData[0].Physician.fax}</td>
                      <td style={{ padding: '5px 10px 0', verticalAlign: 'top' }}>
                        {scriptData[0].Physician?.addressStreet ? `${scriptData[0].Physician.addressStreet},` : ''}
                        <br />
                        {!_.isEmpty(addressPhysician) && addressPhysician.join(', ')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={{ marginTop: '15px', position: 'relative' }}>
                <table style={{
                  position: 'relative', borderCollapse: 'collapse', width: '100%', border: '1px solid #000000', margin: '10px 0 45px', backgroundColor: '#fff',
                }}
                >
                  <thead style={{
                    height: '40px', textAlign: 'left', textTransform: 'uppercase', fontSize: '12px',
                  }}
                  >
                    <tr>
                      <th style={{ padding: '10px', borderRight: '1px solid #000000' }}>Rx number</th>
                      <th style={{ padding: '10px', borderRight: '1px solid #000000' }}>Medication</th>
                      <th style={{ padding: '10px', borderRight: '1px solid #000000' }}>QTY</th>
                      <th style={{ padding: '10px', borderRight: '1px solid #000000' }}>Last Fill</th>
                      <th style={{ padding: '10px' }}>Directions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {script.map((s) => (
                      <tr key={s.id}>
                        <td style={{
                          padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, borderRight: '1px solid #000000',
                        }}
                        >
                          {s.rxNumber}
                        </td>
                        <td style={{
                          padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, borderRight: '1px solid #000000',
                        }}
                        >
                          {s.Product.name}
                        </td>
                        <td style={{
                          padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, borderRight: '1px solid #000000',
                        }}
                        >
                          {s.quantity}
                        </td>
                        <td style={{
                          padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, borderRight: '1px solid #000000',
                        }}
                        >
                          {s.lastFill ? moment(s.lastFill).format('MM/DD/YYYY') : '-'}
                        </td>
                        <td style={{ padding: '10px', borderTop: '1px solid #000000', fontWeight: 400 }}>{s.directions}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ marginTop: '15px', position: 'relative' }}>
                <table style={{
                  position: 'relative', borderCollapse: 'collapse', width: '100%', border: '1px solid #000000', margin: '10px 0 45px', backgroundColor: '#fff',
                }}
                >
                  <thead style={{
                    height: '40px', textAlign: 'left', textTransform: 'uppercase', fontSize: '12px',
                  }}
                  >
                    <tr>
                      <th style={{ padding: '10px', borderRight: '1px solid #000000' }}>Please check one</th>
                      <th style={{ padding: '10px' }}>Doctors Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {info.map((i, index) => (
                      <tr key={i}>
                        <td style={{
                          padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, borderRight: '1px solid #000000', wordBreak: 'break-word',
                        }}
                        >
                          <div>
                            <input
                              style={{ display: 'inline', marginRight: 6 }}
                              type="checkbox"
                              checked={checkedInfo.includes(index)}
                              onChange={() => setCheckedInfo(
                                checkedInfo.includes(index)
                                  ? checkedInfo.filter((i) => i !== index)
                                  : [...checkedInfo, index],
                              )}
                            />
                            <p style={{ display: 'inline' }}>{i}</p>
                          </div>
                        </td>

                        {!index && (
                          <td
                            rowSpan={3}
                            style={{
                              verticalAlign: 'top', padding: '10px', borderTop: '1px solid #000000', fontWeight: 400, width: 380, minWidth: 380,
                            }}
                          >
                            <div>
                              {hasManufacturerId && (
                                <>
                                  <div style={{ marginBottom: '10px' }}>
                                    <div>
                                      <input type="checkbox" style={{ marginRight: 6 }} checked={checkedGender === 'male'} onChange={() => setCheckedGender(checkedGender === 'male' ? null : 'male')} />
                                      Male
                                    </div>

                                    <div>
                                      <input type="checkbox" style={{ marginRight: 6 }} checked={checkedGender === 'female-repro'} onChange={() => setCheckedGender(checkedGender === 'female-repro' ? null : 'female-repro')} />
                                      Female of reproductive potential
                                    </div>

                                    <div>
                                      <input type="checkbox" style={{ marginRight: 6 }} checked={checkedGender === 'female-non-repro'} onChange={() => setCheckedGender(checkedGender === 'female-non-repro' ? null : 'female-non-repro')} />
                                      Female not of reproductive potential
                                    </div>
                                  </div>

                                  <div style={{ ...(comment.trim() ? { borderBottom: '1px solid #000000', paddingBottom: '10px', marginBottom: '10px' } : {}) }}>
                                    <div>
                                      <div style={{ display: 'inline-block', width: 124 }}>
                                        <span style={{ display: 'block' }}>Authorization #</span>
                                        <span style={{ display: 'block', fontSize: '10px' }}>(Physician must provide)</span>
                                      </div>

                                      <div style={{ display: 'inline-block', marginTop: '2px' }}>
                                        <span style={{
                                          display: 'inline-block', marginRight: 6, borderBottom: '2px solid #000', width: '100px',
                                        }}
                                        />
                                        <span>Date</span>
                                        <span style={{
                                          display: 'inline-block', marginLeft: 6, borderBottom: '2px solid #000', fontSize: '14px', width: '80px',
                                        }}
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <div style={{ display: 'inline-block', width: 124 }}>
                                        <span style={{ display: 'block' }}>Confirmation #</span>
                                        <span style={{ display: 'block', fontSize: '10px' }}>(Pharmacy will obtain)</span>
                                      </div>

                                      <div style={{ display: 'inline-block', marginTop: '2px' }}>
                                        <span style={{
                                          display: 'inline-block', marginRight: 6, borderBottom: '2px solid #000', width: '100px',
                                        }}
                                        />
                                        <span>Date</span>
                                        <span style={{
                                          display: 'inline-block', marginLeft: 6, borderBottom: '2px solid #000', fontSize: '14px', width: '80px',
                                        }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}

                              {comment}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ padding: '20px' }}>
                <p style={{ marginTop: '10px' }}>AUTHORIZED BY</p>
                <p style={{ marginTop: '25px', width: 240, borderBottom: '2px solid #000' }} />
                <p style={{ marginTop: '10px' }}>SIGNATURE</p>
                <p style={{ marginTop: '25px', width: 240, borderBottom: '2px solid #000' }} />
                <p style={{ marginTop: '10px' }}>DATE</p>
                <p style={{ marginTop: '25px', width: 240, borderBottom: '2px solid #000' }} />
              </div>

              <div style={{ padding: '20px' }}>
                <h5 style={{ marginBottom: '10px' }}>CONFIDENTIALITY NOTICE</h5>
                <p>
                  The information contained in this transmittal belongs to SortPak Pharmacy and may
                  include information that is confidential, privileged, and protected
                  from disclosure under applicable law.
                  It is intended only for the use of the above physicians. If you are not the intended
                  recipient of this information,
                  you are hereby notified that any disclosure, copying, or distribution of this
                  information is strictly prohibited. If you have received this transmittal in error,
                  please immediately notify us by telephone at (877) 570-7787.
                  Thank you. Please utilize electronic prescribing when possible.
                </p>
              </div>

            </div>

            <div
              className={classes.btn_wrapper}
            >
              <Button
                onClick={onClose}
                clearButton
                title="Cancel"
                type="button"
                className={classes.btn}
              />

              <Button
                onClick={downloadFaxPgf}
                title="Preview"
                type="button"
                className={classes.btn}
                loading={loadBtn.preview}
              />

              <Button
                onClick={sendFax}
                reverseColor
                title="Send Fax"
                type="button"
                className={classes.btn}
                loading={loadBtn.fax}
              />
            </div>
          </div>
        )}
    </Modal>
  );
};

FaxModal.propTypes = {
  modalData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default FaxModal;
